import { Link } from 'react-router';
import { Contact } from '@repo/types';
import { Image, ImageVariant } from '../../../common/components/Image';

type ContactListItemProps = {
  contact: Contact;
};
export default function ContactListItem({ contact }: ContactListItemProps) {
  return (
    <article className="contacts-list__item">
      <div className="contacts-list__item-image-container">
        <Image
          className="contacts-list__item-image"
          variant={ImageVariant.SquareLogoLarge}
          src={contact.image?.length ? contact.image : 'user-icon.png'}
          alt={`${contact.name}-image`}
          width={120}
          height={120}
        />
      </div>
      <span className="contacts-list__item-job-title">{contact.jobTitle}</span>
      <h2 className="contacts-list__item-name">{contact.name}</h2>
      {contact.email && (
        <Link className="contacts-list__item-email" to={`mailto:${contact.email}`}>
          Send email
        </Link>
      )}
      {contact.phone && (
        <Link className="contacts-list__item-phone" to={`tel:${contact.phone}`}>
          {contact.phone}
        </Link>
      )}
    </article>
  );
}
